import noOrgImage from "../assets/pageInfomations/userList/no-org.png";
import createOrgImage from "../assets/pageInfomations/userList/create-org.png";
import orgHierarchyImage from "../assets/pageInfomations/userList/org-hierarchy.png";
import newUsersImage from "../assets/pageInfomations/userList/new-user-requests.png";

// Cargo List Imports
import cargoListImage from "../assets/pageInfomations/CargoList/CargoList.png";
import createNewCargoImage from "../assets/pageInfomations/CargoList/CreateNewCargo.png";
import newCargoCreateModelImage from "../assets/pageInfomations/CargoList/NewCargoCreateModel.png";
import addCargoViaPdfImage from "../assets/pageInfomations/CargoList/AddCargoDetailsViaUploadingPdf.png";
import updateCargoDetailsImage from "../assets/pageInfomations/CargoList/UpdateDetailsOfCargo.png";
import openMatrixModelImage from "../assets/pageInfomations/CargoList/OpenModelForShowCargoInMatrix.png";
import showInMatrixModelImage from "../assets/pageInfomations/CargoList/ShowInMatrixModel.png";
import manageMatrixVisibilityImage from "../assets/pageInfomations/CargoList/ManageShowOrHideInMatrix.png";
import openMoreActionsImage from "../assets/pageInfomations/CargoList/OpenMoreActions.png";
import allCargoListTabImage from "../assets/pageInfomations/CargoList/AllCargoListTab.png";
import openDetailsModelImage from "../assets/pageInfomations/CargoList/openDetailsModel.png";
import cargoDetailsModelInAllOrderImage from "../assets/pageInfomations/CargoList/CargoDetailsModelOpenedInAllOrderTab.png";
import downloadAiInstructionPdfImage from "../assets/pageInfomations/CargoList/downloadAiInstructionPdf.png";
import prevDownloadAiInstructionPdfImage from "../assets/pageInfomations/CargoList/prev_downloadAiInstructionPdf.png";

// Cargo Analysis Imports
import allCargoAnalysisListImage from "../assets/pageInfomations/CargoAnalysis/allcargolist.png";
import cargoAnalysisCalculationDetailsImage from "../assets/pageInfomations/CargoAnalysis/cargoanalysisestimationcalculationdetails.png";
import cargoAnalysisEstimationListImage from "../assets/pageInfomations/CargoAnalysis/cargoanalysisestimationlist.png";
import myCargoAnalysisListImage from "../assets/pageInfomations/CargoAnalysis/cargolist.png";
import openCargoAnalysisViewImage from "../assets/pageInfomations/CargoAnalysis/opencargoanalysisestimationview.png";
import shareWithTeamImage from "../assets/pageInfomations/CargoAnalysis/sharwithteam.png";

// Vessel Manager Imports
import allVesselListImage from "../assets/pageInfomations/VesselList/allVesselList.png";
import viewVesselDetailsAllTabImage from "../assets/pageInfomations/VesselList/viewVesselDetailsInallVesselTab.png";
import viewVesselDetailsModelImage from "../assets/pageInfomations/VesselList/viewVesselDetailsModel.png";
import myVesselListImage from "../assets/pageInfomations/VesselList/MyVesselList.png";
import toggleShowInMatrixImage from "../assets/pageInfomations/VesselList/ToggleShowInMatrix.png";
import manualAddVesselImage from "../assets/pageInfomations/VesselList/manual-addvessel.png";
import manualActionsImage from "../assets/pageInfomations/VesselList/manual-AddandUploadVesselDetailsActions.png";
import manualVerifyRequiredImage from "../assets/pageInfomations/VesselList/manual-openverificationmodelbeforaddfleet.png";
import manualReviewDetailsImage from "../assets/pageInfomations/VesselList/manual-reviewdetails.png";
import manualClickAddFleetImage from "../assets/pageInfomations/VesselList/manual-clickonaddfleet.png";
import vesselMoreActionsImage from "../assets/pageInfomations/VesselList/moreactions.png";
import toggleLiveShareImage from "../assets/pageInfomations/VesselList/toggleliveshare.png";
import fetchVesselFromUsersImage from "../assets/pageInfomations/VesselList/users-fetchvesseldetailsfromusersofyourorg.png";
import selectVesselToCopyImage from "../assets/pageInfomations/VesselList/users-selectvesselwhichyouwantedtocopy.png";
import vesselDetailsModelImage from "../assets/pageInfomations/VesselList/vesselDetailsModel.png";
import viewVesselDetailsImage from "../assets/pageInfomations/VesselList/viewVesselDetails.png";
import autoVesselListImage from "../assets/pageInfomations/VesselList/auto-vesselList.png";
import autoFinalSubmitImage from "../assets/pageInfomations/VesselList/auto-finalSubmit.png";
import autoOpenVesselDetailsImage from "../assets/pageInfomations/VesselList/auto-openvesseldetails.png";
import autoFinalStepVesselDetailsImage from "../assets/pageInfomations/VesselList/auto-finalstepofvesseldetails.png";

// Cargo-Vessel Playground Imports
import playgroundNormalViewImage from "../assets/pageInfomations/CargoVesselPlayground/normalview.png";
import playgroundSelectImage from "../assets/pageInfomations/CargoVesselPlayground/selectvesselandcargo.png";
import playgroundConnectImage from "../assets/pageInfomations/CargoVesselPlayground/connectvesselandcargo.png";
import playgroundCalculationImage from "../assets/pageInfomations/CargoVesselPlayground/calculationsummary.png";
import playgroundMultiConnectImage from "../assets/pageInfomations/CargoVesselPlayground/connectsinglenodetomultiple.png";

// Cargo Vessel Estimation Imports
import openCargoVesselTabImage from "../assets/pageInfomations/cargovesselestimation/opencargovesselestimationtab.png";
import cargoVesselInitialImage from "../assets/pageInfomations/cargovesselestimation/initialview.png";
import shareWithTeamImageCargoVessel from "../assets/pageInfomations/cargovesselestimation/opensharewithteammodel.png";
import cargoVesselDetailsImage from "../assets/pageInfomations/cargovesselestimation/cargovesselestimaioncalcview.png";
import allVoyagesInitialImage from "../assets/pageInfomations/cargovesselestimation/initialviewofallvoyage.png";
import copyToListImage from "../assets/pageInfomations/cargovesselestimation/copyintoyourlistmodel.png";

// Cargo Cargo Estimation Imports
import cargoCargoInitialImage from "../assets/pageInfomations/CargoCargoEstimation/intialview.png";
import openCargoCargoTabImage from "../assets/pageInfomations/CargoCargoEstimation/openCargoCargoEstimation.png";
import cargoCargoDetailsImage from "../assets/pageInfomations/CargoCargoEstimation/CargoCargoEstimationCalculation.png";
import shareCargoWithTeamImage from "../assets/pageInfomations/CargoCargoEstimation/sharewithteammodel.png";
import allCargoInitialImage from "../assets/pageInfomations/CargoCargoEstimation/intialviewforallcargo.png";

// Vessel Vessel Estimation Imports
import vesselVesselInitialImage from "../assets/pageInfomations/VesselVesselEstimation/initalview.png";
import openVesselVesselTabImage from "../assets/pageInfomations/VesselVesselEstimation/OpenVesselVesselEstimation.png";
import vesselVesselDetailsImage from "../assets/pageInfomations/VesselVesselEstimation/VesselVesselEstimationCalc.png";
import shareVesselWithTeamImage from "../assets/pageInfomations/VesselVesselEstimation/opensharemodel.png";
import fleetListInitialImage from "../assets/pageInfomations/VesselVesselEstimation/initalviewofallfleet.png";
import copyVesselToListImage from "../assets/pageInfomations/VesselVesselEstimation/opencopymodel.png";

// All Estimation Imports
import allEstimationInitialImage from "../assets/pageInfomations/AllEstimation/initalview.png";
import cargoContractFormImage from "../assets/pageInfomations/AllEstimation/cargocontract.png";
import vesselContractFormImage from "../assets/pageInfomations/AllEstimation/vesselcontractform.png";
import dualContractFormImage from "../assets/pageInfomations/AllEstimation/vesselcargocontract.png";

// Matrix Calculator Imports
import matrixInitialViewImage from "../assets/pageInfomations/Matrix/initialview.png";
import matrixOpenSaveAsImage from "../assets/pageInfomations/Matrix/opensaveasvoyagemodel.png";
import matrixSaveAsModalImage from "../assets/pageInfomations/Matrix/savevoyagemodel.png";
import matrixTableViewImage from "../assets/pageInfomations/Matrix/tableview.png";
import matrixViewCargoImage from "../assets/pageInfomations/Matrix/viewcargodetails.png";
import matrixCargoDetailsImage from "../assets/pageInfomations/Matrix/cargodetailsmodel.png";
import matrixViewMarginImage from "../assets/pageInfomations/Matrix/viewmarginallowance.png";
import matrixMarginAllowanceImage from "../assets/pageInfomations/Matrix/marginallowancemodel.png";
import matrixViewSplitHireImage from "../assets/pageInfomations/Matrix/viewsplithiredetails.png";
import matrixSplitHireImage from "../assets/pageInfomations/Matrix/splithiremodel.png";
import matrixViewExpenseImage from "../assets/pageInfomations/Matrix/viewexpenseperday.png";
import matrixExpensePerDayImage from "../assets/pageInfomations/Matrix/expenseperdaymodel.png";
import matrixPortListImage from "../assets/pageInfomations/Matrix/portlisttable.png";
import matrixPortChangeImage from "../assets/pageInfomations/Matrix/portchangemodel.png";
import matrixPortDistanceImage from "../assets/pageInfomations/Matrix/portdistancemodel.png";
import matrixBunkerSupplyImage from "../assets/pageInfomations/Matrix/bunkersupplytable.png";
import matrixTermsTableImage from "../assets/pageInfomations/Matrix/termsco-efficienttable.png";

// Position Reader Imports
import viewListImage from "../assets/pageInfomations/PositionReader/viewlist.png";
import toggleAutoAddImage from "../assets/pageInfomations/PositionReader/toggletoaddinautovessellist.png";
import viewThreadedHistoryImage from "../assets/pageInfomations/PositionReader/viewdetailsoflistitem.png";
import viewMailDetailsImage from "../assets/pageInfomations/PositionReader/viewmaildetails.png";
import addedToAutoVesselImage from "../assets/pageInfomations/PositionReader/addeditemlistinautoaddvessel.png";

// Contract Imports - Cargo
import cargoContractInitialImage from "../assets/pageInfomations/Contracts/IntialViewOfCargoContract.png";
import cargoCreateEstimateActionImage from "../assets/pageInfomations/Contracts/cargo-createestimateaction.png";
import cargoCreateEstimateModelImage from "../assets/pageInfomations/Contracts/cargo-createestimatemodel.png";
import cargoIfSelectedCargoCargoImage from "../assets/pageInfomations/Contracts/cargo-ifselectedcargocargoestimate.png";
import cargoIfSelectedVesselCargoImage from "../assets/pageInfomations/Contracts/cargo-ifselectedvesselcargoestimate.png";
import cargoFinalEstimateStepImage from "../assets/pageInfomations/Contracts/cargo-finalestimatestep.png";
import cargoMoreOptionsImage from "../assets/pageInfomations/Contracts/cargo-moreoptions.png";
import contractCargoDetailsImage from "../assets/pageInfomations/Contracts/cargo-cargodetails.png";
import cargoOpenContractDetailsImage from "../assets/pageInfomations/Contracts/cargo-opencargocontractdetails.png";
import cargoShareWithTeamImage from "../assets/pageInfomations/Contracts/cargo-sharewithteam.png";
import cargoDuplicateContractImage from "../assets/pageInfomations/Contracts/cargo-duplicatecargocontract.png";
import cargoManageCounterpartyImage from "../assets/pageInfomations/Contracts/cargo-managecounterpartyincargo.png";

// Contract Imports - Vessel
import vesselContractInitialImage from "../assets/pageInfomations/Contracts/IntialViewOfVesselContract.png";
import vesselViewContractImage from "../assets/pageInfomations/Contracts/vessel-viewvesselcontract.png";
import contractVesselDetailsImage from "../assets/pageInfomations/Contracts/vessel-vesseldetails.png";
import vesselShareWithTeamImage from "../assets/pageInfomations/Contracts/vessel-sharewithteam.png";
import vesselIfSelectedVesselCargoImage from "../assets/pageInfomations/Contracts/vessel-ifselectedvesselcargoestimate.png";
import vesselFinalEstimateStepImage from "../assets/pageInfomations/Contracts/vessel-finalestimatestep.png";
import vesselDuplicateContractImage from "../assets/pageInfomations/Contracts/vessel-duplicatecargocontract.png";
import vesselCreateEstimateModelImage from "../assets/pageInfomations/Contracts/vessel-createestimatemodel.png";

// Contract Imports - Pre-Fix Estimate
import prefixInitialImage from "../assets/pageInfomations/Contracts/IntialViewOfVesselkCargoContract.png";
import prefixShareToOpsStep1Image from "../assets/pageInfomations/Contracts/pre-fix-sharetoopsstep1.png";
import prefixShareToOpsStep2Image from "../assets/pageInfomations/Contracts/pre-fix-sharetoopsstep2.png";
import prefixShareToOpsStep3Image from "../assets/pageInfomations/Contracts/pre-fix-sharetoopsstep3.png";
import prefixShareWithTeamsImage from "../assets/pageInfomations/Contracts/pre-fix-sharewithteams.png";
import vesselVesselContractCalcImage from "../assets/pageInfomations/Contracts/vessel-vessel-contract.png";
import vesselCargoContractCalcImage from "../assets/pageInfomations/Contracts/vessel-cargo-contract.png";
import cargoCargoContractCalcImage from "../assets/pageInfomations/Contracts/cargo-cargo-contract.png";


export const pageInfoData = {
    "/user-list": {
        title: "Understanding the User List & Organization Flow",
        steps: [
            {
                title: "1. No Organization Yet",
                context:
                    "If you are a new user, you will start with an empty state. Click the 'CREATE ORGANIZATION' button to establish your team workspace.",
                imageSrc: noOrgImage,
            },
            {
                title: "2. Create New Organization",
                context:
                    "Provide an Organization Name to manage your team members and share assets. \n\nNote: Creating the base organization is quick, but adding extra users will require an admin approval workflow.",
                imageSrc: createOrgImage,
            },
            {
                title: "3. Organization Hierarchy",
                context:
                    "Once created, you will see a visual flowchart of your organization with yourself placed at the top. To expand your team, click the 'REQUEST FOR USER CREATE' button.",
                imageSrc: orgHierarchyImage,
            },
            {
                title: "4. Requesting New Users & Module Access",
                context: `You can queue up multiple user requests at once. Fill in their First Name, Last Name, and Email Address.
  
  **Role Rules:**
  • User Role: Must be assigned specific modules and needs a "Head" assigned for each of those modules.
  • Head Role: If you assign them as a Head, you (the main requesting user) automatically become their overall Head.
  
  **Available Modules:**
  Chartering, Operations, Accounts, Agency, Ship Management, Admin, Risk Management, Fuel Supply.
  
  Once submitted, this request goes to the System Admin for final approval and editing.`,
                imageSrc: newUsersImage,
            },
        ],
    },
    "/orders": {
        title: "Understanding the Orders Hub",
        tabs: [
            {
                title: "My Orders",
                steps: [
                    {
                        title: "1. The Cargo List Overview",
                        context:
                            "The Orders page is your central hub for managing Cargo requirements. Here you can view, search, and manage all your active cargo requests in a comprehensive table view.",
                        imageSrc: cargoListImage,
                    },
                    {
                        title: "2. Creating New Cargo",
                        context:
                            "Click 'New Order' to build a new cargo requirement. You can define all technical specifications from scratch or use the 'Create New Order' button within an existing cargo modal to duplicate and modify details quickly.",
                        imageSrc: createNewCargoImage,
                    },
                    {
                        title: "3. Build Cargo via Modal",
                        context:
                            "Use the Create Cargo modal to input detailed parameters like Cargo Name, Type, Quantity, and specific load/discharge terms.",
                        imageSrc: newCargoCreateModelImage,
                    },
                    {
                        title: "4. AI-Assisted Import: Preparation",
                        context:
                            "To leverage external AI (like ChatGPT, Claude, or Gemini) for data extraction:\n\n1. Click **Download AI Instruction PDF** in the Cargo Operations section.\n2. Review the instructions in the modal before downloading to understand the required CSV format.",
                        imageSrc: downloadAiInstructionPdfImage,
                    },
                    {
                        title: "",
                        context:
                            "",
                        imageSrc: prevDownloadAiInstructionPdfImage,
                    },
                    {
                        title: "6. Document Automation (PDF)",
                        context:
                            "1. Upload the downloaded Instruction PDF to any supported AI assistant.\n2. Also upload or paste the cargo source data (such as an email, PDF, document, or other cargo-related file) into the same AI conversation.\n3. The AI will generate a standardized CSV file in the required format.\n4. Return to the application and upload the generated CSV using the **Upload PDF or CSV** button.\n5. The system will process the CSV and populate the cargo data automatically.",
                        imageSrc: addCargoViaPdfImage,
                    },
                    {
                        title: "7. Managing & Updating Details",
                        context:
                            "Click on any cargo row to open its detailed view. From here, you can review current terms or click 'Update' to modify quantities, dates, or port requirements.",
                        imageSrc: updateCargoDetailsImage,
                    },
                    {
                        title: "8. Advanced Action Menu",
                        context:
                            "Access extra operations via the 'More Actions' menu (three dots). This includes generating contracts, sharing cargo with your organization, or performing deep cargo analysis.",
                        imageSrc: openMoreActionsImage,
                    },
                    {
                        title: "9. Enabling Cargo for Matrix",
                        context:
                            "Toggle the 'Add to Matrix' switch to make a specific cargo available in the Calculator. This allows you to perform comparative analysis and find the most suitable vessels for your cargo requirements.",
                        imageSrc: openMatrixModelImage,
                    },
                    {
                        title: "10. Cargo-Centric Estimations",
                        context:
                            "Once enabled, you can view how this cargo performs against various vessels in the Matrix. Instantly compare profit margins, freight costs, and operational feasibility for this specific order.",
                        imageSrc: showInMatrixModelImage,
                    },
                    {
                        title: "11. Managing Matrix Visibility",
                        context:
                            "Manage which cargo requirements are currently active in your calculator. You can toggle visibility to focus on specific market opportunities and streamline your estimation workflow.",
                        imageSrc: manageMatrixVisibilityImage,
                    },
                ],
            },
            {
                title: "All Orders",
                steps: [
                    {
                        title: "1. Organization-Wide Shared Cargo",
                        context:
                            "The 'All Orders' tab displays shared cargo requirements from everyone in your organization. This fosters collaboration and resource sharing across teams.",
                        imageSrc: allCargoListTabImage,
                    },
                    {
                        title: "2. Accessing Order Information",
                        context:
                            "Click on any shared order row to initiate the details view. This allows you to explore the technical specifications before deciding to add it to your personal list.",
                        imageSrc: openDetailsModelImage,
                    },
                    {
                        title: "3. Review & Pin to My Orders",
                        context:
                            "Review the technical specifications in the shared cargo details modal. If the order fits your operational requirements, click the 'Create New Order' button. This action will automatically clone the cargo into your personal 'My Orders' list, allowing you to manage and estimate it privately.",
                        imageSrc: cargoDetailsModelInAllOrderImage,
                    },
                ]
            }
        ]
    },
    "/cargo-analysis": {
        title: "Understanding Cargo Analysis",
        tabs: [
            {
                title: "My Cargo",
                steps: [
                    {
                        title: "1. Manage Cargo Analyses",
                        context:
                            "The My Cargo tab is your personal workspace for fleet-wide cargo estimations. Review summaries, manage your list, or use the **Trash** icon to remove outdated analyses.",
                        imageSrc: myCargoAnalysisListImage,
                    },
                    {
                        title: "2. Team Collaboration",
                        context:
                            "Click the **Share** icon in the action column to publish your analysis to the 'All Cargo' tab, making it visible to your entire organization.",
                        imageSrc: shareWithTeamImage,
                    },
                    {
                        title: "3. Detailed Estimation Link",
                        context:
                            "Click on any **Cargo Name** (styled as a blue link) to open the deep-dive estimation view for that specific cargo requirement.",
                        imageSrc: openCargoAnalysisViewImage,
                    },
                    {
                        title: "4. Cargo Analysis Estimation",
                        context:
                            "This view first presents a list of all successful matches and estimations for the cargo. Select an entry to reveal the complete technical breakdown and calculation details.",
                        imageSrc: cargoAnalysisEstimationListImage,
                    },
                    {
                        title: "5. Calculation Deep-Dive",
                        context:
                            "Review every financial and operational detail of the chosen estimation, including TCE, bunker costs, and distance breakdowns.",
                        imageSrc: cargoAnalysisCalculationDetailsImage,
                    }
                ],
            },
            {
                title: "All Cargo",
                steps: [
                    {
                        title: "1. Organization-Wide Analyses",
                        context:
                            "The All Cargo tab displays all estimations shared by your team. It serves as a central knowledge base for ongoing market requirements.",
                        imageSrc: allCargoAnalysisListImage,
                    },
                    {
                        title: "2. Shared Estimation Access",
                        context:
                            "Just like in your personal list, clicking a **Cargo Name** redirects you to the detailed estimation view, allowing you to review team calculations and logic.",
                    },
                ]
            }
        ]
    },
    "/vesselManager": {
        title: "Understanding Vessel Manager",
        tabs: [
            {
                title: "My Vessel",
                steps: [
                    {
                        title: "1. Manage Your Fleet",
                        context:
                            "The My Vessel tab is your primary dashboard for managing active vessels. Here you can search, filter, and review every ship currently in your personal fleet.",
                        imageSrc: myVesselListImage,
                    },
                    {
                        title: "2. Toggle Matrix Visibility",
                        context:
                            "Use the 'Add to Matrix' switch to control which vessels are active in your Calculator. Only enabled vessels will appear as options when performing voyage estimations.",
                        imageSrc: toggleShowInMatrixImage,
                    },
                    {
                        title: "3. Live Sync & Sharing",
                        context:
                            "Enable **Live Share** to keep your estimations in sync. When this is active, any changes you make to the vessel's technical details will automatically propagate to every calculator and matrix where this vessel is currently being used.",
                        imageSrc: toggleLiveShareImage,
                    },
                    {
                        title: "4. Access Technical Profile",
                        context:
                            "Click the 'Eye' icon in the actions column to open the technical summary for a vessel. This provides a quick snapshot of the ship's current configurations and identifiers.",
                        imageSrc: viewVesselDetailsImage,
                    },
                    {
                        title: "5. Detailed Vessel Model & PDF Export",
                        context:
                            "Deep-dive into the Vessel Model to review high-fidelity data like speed/consumption curves and bunker capacities. \n\n**Note:** Use the 'Download PDF' button within this modal to export the vessel's technical specifications. This PDF can be reused later to quickly import this exact data when adding vessels manually.",
                        imageSrc: vesselDetailsModelImage,
                    },
                    {
                        title: "6. Global Sharing & Contracts",
                        context:
                            "Use the action menu (three dots) to access extra operations. You can share your private vessels with the organization to foster collaboration or instantly generate a Vessel Contract for a new fixture.",
                        imageSrc: vesselMoreActionsImage,
                    }
                ],
            },
            {
                title: "Add Vessel (Manual)",
                steps: [
                    {
                        title: "1. Search and Auto-Fill",
                        context: "Start by searching for a vessel name. The system will automatically fetch its core technical data from our global database to save you time on data entry.",
                        imageSrc: manualAddVesselImage,
                    },
                    {
                        title: "2. Port & PDF Automation",
                        context: "Assign an Opening Port and Date. You can also upload a **Vessel Specification PDF** to automatically extract complex technical details directly into the table. You can use the PDF exported from the 'Vessel Model' for perfect data mapping.",
                        imageSrc: manualActionsImage,
                    },
                    {
                        title: "3. Verification Gate",
                        context: "Before adding a vessel, you MUST verify it. A red 'Verify' button indicates that the technical details need a final review to ensure operational accuracy.",
                        imageSrc: manualVerifyRequiredImage,
                    },
                    {
                        title: "4. Technical Detail Review",
                        context: "Clicking 'Verify' opens a comprehensive modal. Review the parsed or fetched data, make any necessary adjustments for your specific voyage, and save.",
                        imageSrc: manualReviewDetailsImage,
                    },
                    {
                        title: "5. Finalizing Your Fleet",
                        context: "Once all rows show the green 'Verified' status, click 'Add Fleet' to finalize the addition of these vessels to your managed list.",
                        imageSrc: manualClickAddFleetImage,
                    }
                ]
            },
            {
                title: "Add Vessel (Auto)",
                steps: [
                    {
                        title: "1. Vessel Sync from Position Reader",
                        context: "This tab displays vessels automatically identified and added from the 'Position Reader' tab. You can review their parsed positions and select an Opening Port if it wasn't automatically identified.",
                        imageSrc: autoVesselListImage,
                    },
                    {
                        title: "2. Technical Verification",
                        context: "Click the 'Verify' button in the action column to open the vessel details modal. This step is mandatory to ensure all technical specifications are correctly populated before adding to your fleet.",
                        imageSrc: autoOpenVesselDetailsImage,
                    },
                    {
                        title: "3. Step-by-Step Validation",
                        context: "Complete all steps within the vessel details modal. Upon clicking 'Finish', the system validates required fields—missing data will trigger a toast notification error. A successful save marks the status as 'Verified'.",
                        imageSrc: autoFinalStepVesselDetailsImage,
                    },
                    {
                        title: "4. Final Fleet Import",
                        context: "To finalize, select your 'Verified' vessels using the checkboxes and click 'Add Fleet'. Once a vessel is successfully added to your list, its row will be disabled to prevent duplicate entries.",
                        imageSrc: autoFinalSubmitImage,
                    }
                ]
            },
            {
                title: "Add Vessel (Users)",
                steps: [
                    {
                        title: "1. Select Team Member",
                        context: "Browse all users in your organization. Selecting a colleague will load a list of vessels they have shared with the team.",
                        imageSrc: fetchVesselFromUsersImage,
                    },
                    {
                        title: "2. Copy Shared Vessel",
                        context: "Choose the vessel you want to clone from their shared list. Click the 'Copy' icon to instantly import a private copy into your personal fleet.",
                        imageSrc: selectVesselToCopyImage,
                    }
                ]
            },
            {
                title: "Add Vessel (AIS / Markets)",
                steps: [
                    {
                        title: "1. Track Live & Market Data",
                        context: "These tabs will soon integrate Live AIS Tracking and Market conditions for instant vessel creation.",
                    },
                ]
            },
            {
                title: "All Vessel",
                steps: [
                    {
                        title: "1. Organization-Wide Shared Fleet",
                        context:
                            "This tab displays all vessels that have been shared with the team by any organization member. It acts as a global asset library.",
                        imageSrc: allVesselListImage,
                    },
                    {
                        title: "2. Inspect Shared Vessel",
                        context:
                            "Click the 'Eye' icon to explore the shared vessel's technical specifications before adding it to your personal fleet.",
                        imageSrc: viewVesselDetailsAllTabImage,
                    },
                    {
                        title: "3. Copy to Your Personal List",
                        context:
                            "Within the shared vessel model, you can review details and then use the 'Finish' button to clone the record into your personal fleet. You can also download the specifications as a PDF for offline reference or re-uploading.",
                        imageSrc: viewVesselDetailsModelImage,
                    },
                ]
            }
        ]
    },
    "/positionReader": {
        title: "Understanding the Position Reader",
        steps: [
            {
                title: "1. View Parsed Vessel Positions",
                context:
                    "The Position Reader automatically extracts vessel data from your emails. Use the filters ('Updated since last', 'Region', 'Vessel Type', 'Gears') to narrow down results and click 'Search' to view the extracted vessel list.",
                imageSrc: viewListImage,
            },
            {
                title: "2. Track with Auto-Add",
                context:
                    "Click the toggle switch on any row to automatically track that vessel's updates. Toggled vessels are synchronized with the 'Auto' tab in your 'Vessel Manager' for unified tracking.",
                imageSrc: toggleAutoAddImage,
            },
            {
                title: "3. View Threaded History",
                context:
                    "Clicking a vessel row loads a threaded view showing the 'Sender', 'Subject', and 'Time' of all associated emails. This allows you to trace the history and origin of the position data.",
                imageSrc: viewThreadedHistoryImage,
            },
            {
                title: "4. Read Original Message Content",
                context:
                    "Selecting an entry from the threaded sub-list reveals the full email details and message content in the right-hand preview pane for terminal verification.",
                imageSrc: viewMailDetailsImage,
            },
            {
                title: "5. Unified Fleet Management",
                context:
                    "Toggled vessels appear seamlessly in the 'Vessel Manager' under the 'Auto' tab, allowing you to easily verify and copy them into your active fleet.",
                imageSrc: addedToAutoVesselImage,
            },
        ],
    },
    "/matrixCurve": {
        title: "Understanding the Matrix Curve",
        steps: [
            {
                title: "1. Matrix Curve Overview",
                context:
                    "The Matrix Curve page allows you to visualize and analyze the relationship between various cargo and vessel parameters. It helps in optimizing voyage estimations and understanding the impact of different variables.",
            },
            {
                title: "2. Data Input and Configuration",
                context:
                    "Input your cargo and vessel data, including quantities, types, and specific vessel characteristics. Configure parameters such as fuel prices, port costs, and voyage duration to generate accurate curves.",
            },
            {
                title: "3. Curve Generation and Analysis",
                context:
                    "Once data is entered, the system generates a matrix curve illustrating key performance indicators. Analyze the curve to identify optimal operating points, potential cost savings, and efficiency improvements.",
            },
            {
                title: "4. Scenario Planning and Comparison",
                context:
                    "Create multiple scenarios by adjusting input parameters to compare different outcomes. This feature helps in strategic decision-making and risk assessment for various voyage conditions.",
            },
        ],
    },
    "/calculator": {
        title: "Understanding the Voyage Estimation Matrix",
        steps: [
            {
                title: "1. The Matrix Dashboard Overview",
                context:
                    "The Matrix is a high-performance workspace for simulating maritime logistics. \n\n• **Cargo Selector (Left):** Load your baseline cargo requirements.\n• **Comparison Matrix (Center):** A dynamic table for comparing multiple vessels simultaneously.\n• **Action Menu (Top Right):** Controls for calculations, saving, and PDF exports.\n• **Interactive Map (Bottom):** Visualizes the full port rotation and geographical route.",
                imageSrc: matrixInitialViewImage,
            },
            {
                title: "2. Save & Version Control Trigger",
                context:
                    "Once you have configured your voyage parameters, use the **'Calculate & Save'** or **'Save As'** options in the Action Menu. This ensures your estimation is stored in the system for future reference and organization-wide sharing.",
                imageSrc: matrixOpenSaveAsImage,
            },
            {
                title: "3. Finalizing Voyage Label",
                context:
                    "The Save Voyage modal allows you to assign a specific **Voyage Label** and **Voyage Name**. This metadata is critical for identifying your estimations later within the 'All Estimations' dashboard.",
                imageSrc: matrixSaveAsModalImage,
            },
            {
                title: "4. Vessel Comparison Matrix",
                context:
                    "The central matrix lists available vessels against your selected cargo. Input variable costs like Hire Per Day directly into the table to instantly see the financial impact on TC Eq, Profit, and Freight Costs across your entire fleet.",
                imageSrc: matrixTableViewImage,
            },
            {
                title: "5. Accessing Cargo Details",
                context:
                    "Technical cargo requirements are managed through the **'Cargo Details'** header in the expanded vessel view. Clicking this acts as a trigger to open the detailed management interface.",
                imageSrc: matrixViewCargoImage,
            },
            {
                title: "6. Precision Cargo Management",
                context:
                    "The **View Cargo** modal acts as the master control for cargo requirements. Adjust loading rates, quantities, and commission percentages port-by-port, or attach essential documentation directly to the order record.",
                imageSrc: matrixCargoDetailsImage,
            },
            {
                title: "7. Margin & Allowance Control",
                context:
                    "Performance buffers are set via the **'Margin and Allowances'** header. This area allows you to define safety and performance margins for the overall voyage simulation.",
                imageSrc: matrixViewMarginImage,
            },
            {
                title: "8. Leg-by-Leg Safety Factors",
                context:
                    "Get highly granular with the **Margin Allowances Table**. Define Dwf (%), Speed Factors, and specific safety margins for bunker consumption for every individual leg of the journey for ultra-precise fuel and time projections.",
                imageSrc: matrixMarginAllowanceImage,
            },
            {
                title: "9. Variable Pricing (Hire Per Day)",
                context:
                    "Precision financial modeling begins by clicking the **'Hire Per Day'** label. This trigger allows you to move beyond flat rates and define complex pricing structures.",
                imageSrc: matrixViewSplitHireImage,
            },
            {
                title: "10. Multi-Tiered Financial Modeling",
                context:
                    "Use the **Split Hire** modal to define variable pricing structures—useful for contracts where daily costs change after a specific duration (e.g., $25k for the first 10 days, $30k thereafter).",
                imageSrc: matrixSplitHireImage,
            },
            {
                title: "11. Itemizing Running Costs",
                context:
                    "Financial transparency is achieved through the **'Expenses Per Day'** trigger. Instead of a single lump sum, this section allows for detailed accounting of daily vessel expenses.",
                imageSrc: matrixViewExpenseImage,
            },
            {
                title: "12. Comprehensive Expense Itemization",
                context:
                    "Break down your total daily running costs into specific categories like Crew Victualling (CVE) and Insurance. The system automatically tallies these for accurate financial accounting.",
                imageSrc: matrixExpensePerDayImage,
            },
            {
                title: "13. The Port Rotation Itinerary",
                context:
                    "Manage your voyage sequence from the **Port Rotation Itinerary**. Use the '+' icon to add ports or the 'Burger' handle to drag-and-drop rows to reorder the chronological sequence of events.",
                imageSrc: matrixPortListImage,
            },
            {
                title: "14. Quick Port Swapping",
                context:
                    "Click directly on a port name to open the **Change Bunkering Port** modal. This allows you to select a different port from the dropdown and recalculate distances without recreating the itinerary row.",
                imageSrc: matrixPortChangeImage,
            },
            {
                title: "15. Precise Distance Calculation",
                context:
                    "Click the distance columns to access the **Port Distance** modal. Override system defaults with custom routing through Normal and ECA zones, or specifically configure canal traversals.",
                imageSrc: matrixPortDistanceImage,
            },
            {
                title: "16. Operational Fuel Ledger (Bunker Supply)",
                context:
                    "Manage your fuel inventory at every stop via the **Bunker Supply Table**. Track fuel on-board, supplied quantities, and manage precise manual fuel pricing for accurate operational expense tracking.",
                imageSrc: matrixBunkerSupplyImage,
            },
            {
                title: "17. Chartering Terms Reference",
                context:
                    "Click any value in the Terms column to view the **Terms Co-efficient Table**. This reference displays the multipliers the system uses to calculate port time based on standard maritime contracts (SHINC vs. SHEX).",
                imageSrc: matrixTermsTableImage,
            },
        ],
    },
    "/cargovessel": {
        title: "Understanding Cargo Vessel Estimation",
        tabs: [
            {
                title: "My Voyages",
                steps: [
                    {
                        title: "1. Personal Voyage Repository",
                        context:
                            "The 'My Voyages' tab displays all estimations created by you. You can view critical metadata at a glance, including Voyage Labels, Vessel Names, Load/Discharge Ports, and the creation date.",
                        imageSrc: cargoVesselInitialImage,
                    },
                    {
                        title: "2. Accessing Cargo Vessel Estimations",
                        context:
                            "Navigate to the Cargo Vessel Estimation tab to manage your stored voyage simulations. This dashboard acts as your personal repository for all saved calculations.",
                        imageSrc: openCargoVesselTabImage,
                    },
                    {
                        title: "3. Detailed Calculation Review",
                        context:
                            "Clicking on any Voyage Label or Name opens the detailed calculation view. This allows you to revisit the complete operational and financial simulation including port rotations and profit projections.",
                        imageSrc: cargoVesselDetailsImage,
                    },
                    {
                        title: "4. Sharing with Organization",
                        context:
                            "Click the 'Share' icon in the Actions column to make your estimation available to your entire team. You can provide a unique name for the shared version to help team members identify it.",
                        imageSrc: shareWithTeamImageCargoVessel,
                    },
                ],
            },
            {
                title: "All Voyages",
                steps: [
                    {
                        title: "1. Organization-Wide Simulations",
                        context:
                            "The 'All Voyages' tab lists estimations that have been shared by other members of your organization. It promotes collaboration and allows for the standardization of voyage planning across the team.",
                        imageSrc: allVoyagesInitialImage,
                    },
                    {
                        title: "2. Leveraging Team Insights",
                        context:
                            "Instead of starting from scratch, you can click the 'Copy' icon to clone an existing shared estimation into your personal 'My Voyages' list for further refinement and adjustments.",
                        imageSrc: copyToListImage,
                    },
                ],
            },
        ],
    },
    "/cargo-cargo-matrix": {
        title: "Understanding Cargo Cargo Estimation",
        tabs: [
            {
                title: "My Cargo",
                steps: [
                    {
                        title: "1. Personal Cargo Repository",
                        context:
                            "The 'My Cargo' tab acts as your personal workspace for comparative cargo-to-cargo estimations. Easily track estimations by Name, Ports, and specific Cargo details across your historical simulations.",
                        imageSrc: cargoCargoInitialImage,
                    },
                    {
                        title: "2. Accessing Cargo Cargo Matrices",
                        context:
                            "Navigate to the Cargo Cargo Estimation section to manage your comparative matrices and identify the most profitable cargo pairings for your fleet operations.",
                        imageSrc: openCargoCargoTabImage,
                    },
                    {
                        title: "3. Detailed Comparative Review",
                        context:
                            "Click on any estimation name to launch the full calculation dashboard. This provides a deep dive into the comparative metrics, load sequences, and financial projections for the selected cargo pair.",
                        imageSrc: cargoCargoDetailsImage,
                    },
                    {
                        title: "4. Sharing Insights",
                        context:
                            "Collaborate with your team by sharing critical estimations. Use the 'Share' action to push your matrix to the organization list, ensuring standard planning across departments.",
                        imageSrc: shareCargoWithTeamImage,
                    },
                ],
            },
            {
                title: "All Cargo",
                steps: [
                    {
                        title: "1. Organization Cargo Repository",
                        context:
                            "The 'All Cargo' tab provides visibility into estimations shared by your team. This organization-wide repository helps in standardizing cargo estimations and leveraging prior work from colleagues.",
                        imageSrc: allCargoInitialImage,
                    },
                ],
            },
        ],
    },
    "/vessel-vessel-matrix": {
        title: "Understanding Vessel Vessel Estimation",
        tabs: [
            {
                title: "My Vessel",
                steps: [
                    {
                        title: "1. Personal Vessel Repository",
                        context:
                            "The 'My Vessel' tab acts as your personal storage for all vessel-to-vessel estimations. Monitor critical metrics such as Vessel Names, DWT, and Port locations across your saved simulations.",
                        imageSrc: vesselVesselInitialImage,
                    },
                    {
                        title: "2. Accessing Vessel Vessel Matrices",
                        context:
                            "Navigate to the Vessel Vessel Estimation segment to manage your stored comparisons. This dashboard acts as your central repository for cross-vessel performance metrics.",
                        imageSrc: openVesselVesselTabImage,
                    },
                    {
                        title: "3. Detailed Calculation Review",
                        context:
                            "Clicking on any estimation name opens the detailed calculation dashboard. This allows you to revisit the complete engineering simulation and profit projections for the compared vessels.",
                        imageSrc: vesselVesselDetailsImage,
                    },
                    {
                        title: "4. Sharing with Organization",
                        context:
                            "Leverage the 'Share' icon to make your estimation public within your organization. Assign a clear label to help your team members identify and utilize your findings.",
                        imageSrc: shareVesselWithTeamImage,
                    },
                ],
            },
            {
                title: "Fleet List",
                steps: [
                    {
                        title: "1. Organization Fleet Overview",
                        context:
                            "The 'Fleet List' tab displays all vessel-to-vessel estimations shared by your team. This centralized view ensures everyone is working with the latest shared fleet data.",
                        imageSrc: fleetListInitialImage,
                    },
                    {
                        title: "2. Cloning Team Matrices",
                        context:
                            "Found a useful estimation? Click the 'Copy' icon to clone it into your personal list. Provide a new label to customize the estimation for your specific operational requirements.",
                        imageSrc: copyVesselToListImage,
                    },
                ],
            },
        ],
    },
    "/all-estimation": {
        title: "Understanding All Estimations",
        steps: [
            {
                title: "1. Master Estimation Dashboard",
                context:
                    "The All Estimation page serves as a centralized archive for every simulation conducted across the platform. It provides a high-level summary of Vessel-Vessel, Cargo-Cargo, and Vessel-Cargo matrices in a single unified view.",
                imageSrc: allEstimationInitialImage,
            },
            {
                title: "2. Cargo-Cargo Contract Generation",
                context:
                    "For 'Cargo-Cargo' type estimations, clicking 'Create Contract' launches the intelligent Cargo Chartering platform. This automatically populates relevant cargo details into the contract engine for immediate finalization.",
                imageSrc: cargoContractFormImage,
            },
            {
                title: "3. Vessel-Vessel Contract Generation",
                context:
                    "When working with 'Vessel-Vessel' simulations, the contract engine generates a standard vessel-centric agreement, allowing you to finalize terms specific to fleet management and performance benchmarks.",
                imageSrc: vesselContractFormImage,
            },
            {
                title: "4. Vessel-Cargo Dual Contract Generation",
                context:
                    "In 'Vessel-Cargo' scenarios, the engine simultaneously triggers both Cargo and Vessel contract workflows. This ensures both sides of the logistics equation are documented under a single unified dashboard.",
                imageSrc: dualContractFormImage,
            },
            {
                title: "5. Global Search & Archive Audit",
                context:
                    "Easily locate historical data using the search bar to filter by Voyage Label or Name. Combined with the date-range filter, this ensures complete traceability of all simulations performed by the organization.",
                imageSrc: allEstimationInitialImage,
            },
        ],
    },
    "/contracts": {
        title: "Understanding the Contracts Page",
        tabs: [
            {
                title: "Cargo Contracts",
                steps: [
                    {
                        title: "1. Cargo Contract List Overview",
                        context:
                            "The Cargo Contracts tab displays all your cargo-related contracts in a detailed table. Each contract shows its **Operation Type** (Cargo-Cargo, Vessel-Cargo, or unassigned), **Status** (Open or Closed), Cargo Name, Ports, and key dates.\n\n• **Cargo-Cargo:** A contract where both sides are cargo-focused.\n• **Vessel-Cargo:** A contract linking a vessel to cargo.\n• **No Status Yet:** A freshly created contract with no operation type assigned.",
                        imageSrc: cargoContractInitialImage,
                    },
                    {
                        title: "2. Contract Actions (Open Status)",
                        context:
                            "Each contract row has action icons that vary based on contract status:\n\n• **Eye Icon:** Click to view and open the full cargo contract details.\n• **Create Estimate (Open-in-New Icon):** Only visible for contracts with **'Open'** status. Click to launch the estimate creation wizard.\n• **Trash Icon:** Only visible for contracts that are **not closed**. Click to permanently delete the contract.",
                        imageSrc: cargoCreateEstimateActionImage,
                    },
                    {
                        title: "3. View Cargo Contract Details",
                        context:
                            "Clicking the **Eye** icon opens the full cargo contract detail view. Here you can review all contract terms, port rotations, cargo specifications, and financial parameters associated with this contract.",
                        imageSrc: cargoOpenContractDetailsImage,
                    },
                    {
                        title: "4. Create Estimate — Select Contract Type",
                        context:
                            "When you click the **Create Estimate** action, a modal wizard opens with two options:\n\n• **Cargo-Cargo Contract:** Select this if the estimate involves cargo-to-cargo operations.\n• **Vessel-Cargo Contract:** Select this if the estimate pairs a vessel with cargo.\n\nYour selection here determines the next steps in the wizard.",
                        imageSrc: cargoCreateEstimateModelImage,
                    },
                    {
                        title: "5. If Cargo-Cargo Selected — Vessel Selection (Optional)",
                        context:
                            "When you select **Cargo-Cargo**, the wizard advances to a vessel selection step. This step is **optional** — you can choose a vessel for reference or skip it entirely to proceed without vessel assignment.",
                        imageSrc: cargoIfSelectedCargoCargoImage,
                    },
                    {
                        title: "6. If Vessel-Cargo Selected — Vessel Selection (Required)",
                        context:
                            "When you select **Vessel-Cargo**, the wizard advances to vessel selection where choosing a vessel is **mandatory**. You must assign a vessel before proceeding to the final step of the estimate creation.",
                        imageSrc: cargoIfSelectedVesselCargoImage,
                    },
                    {
                        title: "7. Final Estimate Step — Confirm & Create",
                        context:
                            "The final wizard step presents the contract summary for confirmation. Fill in the required fields and click **Finish** to generate the Pre-Fix Estimate. Upon completion, the system creates the estimate and automatically redirects you to the **Pre-Fix Estimate** tab.",
                        imageSrc: cargoFinalEstimateStepImage,
                    },
                    {
                        title: "8. More Actions Menu (Three Dots)",
                        context:
                            "Click the **'...'** (three-dot) menu on any contract row for additional operations:\n\n• **Update Cargo:** Opens the cargo detail editor to modify cargo specifications.\n• **Share Contract:** Share this contract with other members of your team.\n• **Duplicate Contract:** Create an exact copy of the contract for a new scenario.\n• **Manage CounterParty:** Add or manage counterparty details linked to this cargo contract.\n• **Perform Cargo Analysis:** Launch a detailed cargo analysis for this contract.",
                        imageSrc: cargoMoreOptionsImage,
                    },
                    {
                        title: "9. Update Cargo Details",
                        context:
                            "Selecting **'Update Cargo'** from the more options menu opens the comprehensive cargo detail editor. Here you can modify quantities, cargo type, loading rates, and port-specific parameters.",
                        imageSrc: contractCargoDetailsImage,
                    },
                    {
                        title: "10. Share Contract with Team",
                        context:
                            "Use the **Share** action to make this contract visible to other organization members. Enter a descriptive name and confirm to share the contract with your team for collaborative planning.",
                        imageSrc: cargoShareWithTeamImage,
                    },
                    {
                        title: "11. Duplicate Cargo Contract",
                        context:
                            "The **Duplicate** action creates an exact copy of the selected cargo contract. This is useful when you need to create similar contracts with minor variations without re-entering all details from scratch.",
                        imageSrc: cargoDuplicateContractImage,
                    },
                    {
                        title: "12. Manage Counterparty",
                        context:
                            "Use **Manage Counterparty** to link, update, or remove counterparty information for this cargo contract. This helps maintain accurate records of all parties involved in the chartering agreement.",
                        imageSrc: cargoManageCounterpartyImage,
                    },
                ],
            },
            {
                title: "Vessel Contracts",
                steps: [
                    {
                        title: "1. Vessel Contract List Overview",
                        context:
                            "The Vessel Contracts tab mirrors the Cargo Contracts layout but focuses on vessel-side chartering. Each contract displays its **Operation Type** (Vessel-Vessel or Vessel-Cargo), **Status** (Open or Closed), Vessel Name, Ports, and key dates.",
                        imageSrc: vesselContractInitialImage,
                    },
                    {
                        title: "2. View Vessel Contract Details",
                        context:
                            "Click the **Eye** icon in the Actions column to open and review the full vessel contract. This displays all vessel specifications, charter terms, and operational parameters.",
                        imageSrc: vesselViewContractImage,
                    },
                    {
                        title: "3. Create Estimate — Select Contract Type",
                        context:
                            "Click the **Create Estimate** icon (available only for **Open** status contracts) to launch the wizard. Choose between:\n\n• **Vessel-Vessel Contract:** Both sides are vessel-focused.\n• **Vessel-Cargo Contract:** Pairs this vessel with a cargo requirement.\n\nThe selection determines the subsequent wizard steps.",
                        imageSrc: vesselCreateEstimateModelImage,
                    },
                    {
                        title: "4. Vessel-Cargo Selected — Vessel Assignment",
                        context:
                            "If you choose **Vessel-Cargo**, the wizard requires you to complete the vessel assignment step. This links the vessel contract to a specific cargo operation for the estimate.",
                        imageSrc: vesselIfSelectedVesselCargoImage,
                    },
                    {
                        title: "5. Final Estimate Step — Confirm & Create",
                        context:
                            "Complete the final fields and click **Finish** to generate the Pre-Fix Estimate. The system creates the record and redirects you to the **Pre-Fix Estimate** tab where the new estimate appears with 'Open' status.",
                        imageSrc: vesselFinalEstimateStepImage,
                    },
                    {
                        title: "6. Vessel Details Editor",
                        context:
                            "From the more options menu, select **'Update Vessel'** to open the vessel detail editor. Modify vessel specifications, DWT, speed/consumption profiles, and other technical parameters.",
                        imageSrc: contractVesselDetailsImage,
                    },
                    {
                        title: "7. Share Vessel Contract",
                        context:
                            "Use the **Share** action to make the vessel contract available to your organization. Provide a name and confirm to enable team-wide collaboration on this charter.",
                        imageSrc: vesselShareWithTeamImage,
                    },
                    {
                        title: "8. Duplicate Vessel Contract",
                        context:
                            "Click **Duplicate** from the more options menu to create an identical copy of the vessel contract. Useful for creating variations of an existing charter agreement.",
                        imageSrc: vesselDuplicateContractImage,
                    },
                ],
            },
            {
                title: "Pre-Fix Estimate",
                steps: [
                    {
                        title: "1. Pre-Fix Estimate Dashboard",
                        context:
                            "The Pre-Fix Estimate tab consolidates all finalized estimate contracts. Contracts that show **'Closed'** status in the Cargo or Vessel Contracts tabs appear here with **'Open'** status, ready for operational work.\n\nThe table displays Operation Type, Status, Operation Name (as a clickable link), Vessel/Cargo Names, Ports, Estimation Date, and Remarks.",
                        imageSrc: prefixInitialImage,
                    },
                    {
                        title: "2. Open Estimate Calculation",
                        context:
                            "Click on any **Operation Name** link to open the corresponding calculation view. The type of calculation that opens depends on the contract's operation type:\n\n• **Vessel-Vessel:** Opens the Vessel-Vessel estimation calculator.\n• **Vessel-Cargo:** Opens the Vessel-Cargo estimation calculator.\n• **Cargo-Cargo:** Opens the Cargo-Cargo estimation calculator.",
                    },
                    {
                        title: "3. Vessel-Vessel Calculation View",
                        context:
                            "For **Vessel-Vessel** type contracts, clicking the operation name opens the vessel-to-vessel estimation calculator with full financial and operational simulations.",
                        imageSrc: vesselVesselContractCalcImage,
                    },
                    {
                        title: "4. Vessel-Cargo Calculation View",
                        context:
                            "For **Vessel-Cargo** type contracts, the operation link opens the combined vessel-cargo estimation calculator, showing both vessel performance and cargo logistics in a unified dashboard.",
                        imageSrc: vesselCargoContractCalcImage,
                    },
                    {
                        title: "5. Cargo-Cargo Calculation View",
                        context:
                            "For **Cargo-Cargo** type contracts, the link opens the cargo-to-cargo comparative estimation calculator for analyzing cargo pairing profitability.",
                        imageSrc: cargoCargoContractCalcImage,
                    },
                    {
                        title: "6. Pre-Fix Estimate Actions",
                        context:
                            "Each estimate row provides action icons:\n\n• **Share Icon:** Opens the 'Share to Operation' wizard to push this estimate into the Operations module.\n• **Open-in-New Icon:** Opens the estimate calculation in a new tab for detailed review.\n• **Trash Icon:** Delete the pre-fix estimate record.",
                        imageSrc: prefixInitialImage,
                    },
                    {
                        title: "7. Share to Operation — Step 1: Select Sharing Type",
                        context:
                            "Click the **Share** icon to open the 'Share to Operation' wizard. The first step asks you to choose the sharing method:\n\n• **Share as Private:** The contract will be shared to Operations and visible **only** to a specific user you select in the next step.\n• **Share as Common:** The contract will be shared into common Operations and visible to **all users** in your organization.",
                        imageSrc: prefixShareToOpsStep1Image,
                    },
                    {
                        title: "8. Share to Operation — Step 2: Select User (Private Only)",
                        context:
                            "If you selected **'Share as Private'**, this step displays all **Head** users from the Operation module along with their team members. Expand any Head to see their team.\n\nYou can select **only one user** — the contract will be exclusively visible to that selected user in the Operations module.",
                        imageSrc: prefixShareToOpsStep2Image,
                    },
                    {
                        title: "9. Share to Operation — Step 3: Confirm Sharing",
                        context:
                            "The final step confirms your sharing selection. Provide an **Operation Name** for the shared contract. Toggle **'Team View'** if you want all team members to view the operation.\n\n**Important:** Once shared, this contract will be marked as **'Closed'** in the Pre-Fix Estimate tab and will no longer be editable.",
                        imageSrc: prefixShareToOpsStep3Image,
                    },
                    {
                        title: "10. Share Estimate with Team",
                        context:
                            "Alternatively, use the **Share Estimate Contract with Team** modal to share the estimate within your chartering team. Enter an estimate name and click **Share** to make it available to colleagues for reference and collaboration.",
                        imageSrc: prefixShareWithTeamsImage,
                    },
                ],
            },
        ],
    },
    "/operations": {
        title: "Understanding the Operations Page",
        tabs: [
            {
                title: "My Operations",
                steps: [
                    {
                        title: "1. Personal Workspace",
                        context:
                            "This section is your personal workspace, showing all operations that are currently assigned to you. The table lists all operations under your management, with key details like operation type, vessel and cargo names, and who assigned it.",
                    },
                    {
                        title: "2. Team Collaboration",
                        context:
                            "• **Team Visibility:** Use the **'Team View'** switch to make any of your operations visible to your entire team. This is useful for collaboration and transparency.\n• **Re-assign Tasks:** If you need to delegate an operation, click the **'open in new'** icon in the 'Actions' column to assign it to another user.",
                    },
                    {
                        title: "3. Open Calculator",
                        context:
                            "Click on an operation's name to open the detailed operation calculator page.",
                    },
                ],
            },
            {
                title: "Common Operations",
                steps: [
                    {
                        title: "1. Unassigned Tasks",
                        context:
                            "This section acts as a pool of unassigned tasks that are available to the entire organization.",
                    },
                    {
                        title: "2. Claim an Operation",
                        context:
                            "If you want to take ownership of a task, click the **'open in new'** icon to assign it to yourself. It will then move to your 'My Operations' list.",
                    },
                    {
                        title: "3. Review Details",
                        context:
                            "Click on any operation name to view its details in the operation calculator before deciding to claim it.",
                    },
                ],
            },
            {
                title: "Team Operations",
                steps: [
                    {
                        title: "1. Team's Workspace",
                        context:
                            "This section provides a view of all operations that your team members have marked as visible to the team.",
                    },
                    {
                        title: "2. Monitor Team Activity",
                        context:
                            "Keep track of what your team is working on and view operation details by clicking on any operation name to open the calculator and review the specifics of that task.",
                    },
                ],
            },
        ],
    },
    "/market-curve-analysis": {
        title: "Understanding the Market Curve Analysis",
        steps: [
            {
                title: "1. Vessel Index Chart",
                context:
                    "The main chart displays the historical data for the selected vessel indexes. You can hover over the chart to see detailed values for specific dates.",
            },
            {
                title: "2. Select Vessel Indexes",
                context:
                    "Use the sidebar to select up to 10 vessel indexes to compare. You can search for specific indexes using the search bar.",
            },
            {
                title: "3. Date Range",
                context:
                    "Adjust the date range for the chart to focus on a specific period.",
            },
            {
                title: "4. View Route",
                context:
                    "Click the 'View Route' button to see the geographical routes for the selected indexes on a map.",
            },
            {
                title: "5. Index Details",
                context:
                    "Click the info icon next to an index in the sidebar to view detailed information, including a description, vessel details, and the ports involved. From here, you can also view the specific route for that index.",
            },
            {
                title: "6. Reset Selection",
                context:
                    "Click the 'Reset Selection' button to restore the default set of selected indexes.",
            },
        ],
    },
    "/my-market-curve-analysis": {
        title: "Understanding My Market Curve Analysis",
        steps: [
            {
                title: "1. Custom and Public Indexes",
                context:
                    "The sidebar lists both the indexes you have created and the public indexes available to everyone.",
            },
            {
                title: "2. Create and Manage Your Indexes",
                context:
                    "• **Create New Index:** Click the 'Create New Index' button to define your own vessel index with custom parameters.\n• **Insert Index Data:** Use the 'Insert Index Data' button to add historical data points to your custom indexes, either manually or by uploading a CSV file.\n• **Edit Your Indexes:** Click the 'Edit' icon on one of your indexes in the list to modify its details.",
            },
            {
                title: "3. Analyze and Visualize",
                context:
                    "• **Interactive Chart:** Select up to 10 indexes to visualize and compare their performance over time on the main chart.\n• **Date Range:** Adjust the date range to focus on specific periods.\n• **View Routes:** Click the 'View Route' button to see the geographical routes for your selected indexes on a map.",
            },
            {
                title: "4. Index Details",
                context:
                    "Click the 'Info' icon on any index to see a detailed breakdown of its properties, including descriptions, vessel details, and associated ports.",
            },
        ],
    },
    "/userOrganization": {
        title: "Understanding User Management for Organization",
        steps: [
            {
                title: "1. Organization and User List",
                context:
                    "As a super admin, you can view users across all organizations or filter by a specific one. Regular admins will see a list of users belonging to their organization. The table displays key user details, and you can search for users and filter the list by date.",
            },
            {
                title: "2. User Management Actions",
                context:
                    "• **Create User:** Click the 'Create User' button to add a new user.\n• **Edit User:** Use the 'Edit' action to update a user's information.\n• **Activate/Deactivate:** You can activate or deactivate user accounts.",
            },
            {
                title: "3. User Requests",
                context:
                    "The notification bell icon indicates pending user creation requests. Click it to view, edit, approve, or reject new user requests. You can also assign modules and heads to the new users.",
            },
            {
                title: "4. Login as User (Super Admin)",
                context:
                    "Super admins can log in as any user by clicking the 'share' icon, which is useful for troubleshooting and support.",
            },
        ],
    },
    "/vesselInformation": {
        title: "Understanding Vessel Information Management",
        steps: [
            {
                title: "1. Vessel List Tab (Super Admin Only)",
                context:
                    "This tab displays a comprehensive list of all vessels in the master database. You can search for vessels and edit their core details.",
            },
            {
                title: "2. Fleet List Tab (Super Admin Only)",
                context:
                    "This tab shows fleets created by different organizations. You can switch between organizations, review fleets, and approve them to create master vessel records.",
            },
            {
                title: "3. Creating and Updating Vessels",
                context:
                    "• **Create Vessel:** Add a new vessel to the master list with detailed information.\n• **Update from Fleet:** When editing a fleet, you can create a new master vessel from its data or discard the fleet.",
            },
        ],
    },
    "/organization": {
        title: "Understanding Setup Organization",
        steps: [
            {
                title: "1. Organization List",
                context:
                    "The main table provides a comprehensive overview of all organizations, including their name, ID, assigned admin, domain, and current status (Active or Deactivated).",
            },
            {
                title: "2. Create Organization",
                context:
                    "Click the 'Create Organization' button to add a new organization. You will need to provide the organization's name, domain, and type. Super admins can also assign an admin.",
            },
            {
                title: "3. Manage Organizations",
                context:
                    "• **Edit:** Click the 'Edit' icon to modify the details of an existing organization.\n• **Activate/Deactivate:** Use the 'Activate' or 'Deactivate' actions to change the status of an organization.",
            },
        ],
    },
    "/distance-matrix": {
        title: "Understanding Distance Estimation",
        steps: [
            {
                title: "1. Enter Port Locations",
                context:
                    "Add a series of ports to the list using the search fields. You can also choose to avoid the Suez and Panama canals. Click 'Show Route' to calculate distances and visualize the route on the map. Enter a speed to estimate travel time.",
            },
            {
                title: "2. Select Custom Locations",
                context:
                    "Click directly on the map to add waypoints. The distance between points will be calculated automatically. Use the 'Route Settings' and 'Map Settings' to customize the calculation and map display.",
            },
        ],
    },
    "/cargo-vessel-playground": {
        title: "Understanding the Cargo-Vessel Playground",
        steps: [
            {
                title: "1. The Interactive Workspace",
                context: "The Playground features a central interactive canvas flanked by two sidebars: Cargoes on the left and Vessels on the right. This layout provides a focused environment for visual voyage simulation.",
                imageSrc: playgroundNormalViewImage,
            },
            {
                title: "2. Selection & Node Creation",
                context: "Simply select any cargo or vessel from the sidebars. These items instantly manifest as draggable nodes within the central diagram, ready to be integrated into your simulation.",
                imageSrc: playgroundSelectImage,
            },
            {
                title: "3. Linking Requirements",
                context: "Establish a relationship by connecting a Cargo node to a Vessel node. This visual link signifies a potential match for which the system will automatically perform deep-dive estimations.",
                imageSrc: playgroundConnectImage,
            },
            {
                title: "4. Dynamic Calculation Nodes",
                context: "Upon connection, a dedicated Calculation Node automatically appears. It displays real-time price details and financial metrics, giving you an immediate summary of the voyage's feasibility.",
                imageSrc: playgroundCalculationImage,
            },
            {
                title: "5. Comparative Scenarios",
                context: "Maximize your analysis by connecting single items to multiple counterparts. This allows for rapid side-by-side comparison of different vessel options for the same cargo, or vice-versa.",
                imageSrc: playgroundMultiConnectImage,
            },
        ],
    },
    "/administration": {
        title: "Understanding Administration",
        steps: [
            {
                title: "1. Administration Overview",
                context:
                    "The Administration page is a central hub for managing administrative tasks within the application. From here, you can access various administrative functions and settings.",
            },
            {
                title: "2. User and Role Management",
                context:
                    "Manage users, roles, and permissions to control access to different parts of the application. You can add new users, assign roles, and define what each role can see and do.",
            },
            {
                title: "3. System Configuration",
                context:
                    "Configure system-wide settings and parameters. This may include setting up integrations, defining application-wide defaults, and managing other configuration options.",
            },
        ],
    },
    "/risk-management": {
        title: "Understanding Risk Management",
        steps: [
            {
                title: "1. Risk Management Dashboard",
                context:
                    "The Risk Management dashboard provides an overview of potential risks associated with your operations. It helps you identify, assess, and mitigate risks to ensure smooth and safe voyages.",
            },
            {
                title: "2. Risk Analysis Tools",
                context:
                    "Use the available tools to perform detailed risk analysis. This includes scenario planning, what-if analysis, and other techniques to understand the potential impact of different risk factors.",
            },
            {
                title: "3. Mitigation Strategies",
                context:
                    "Develop and implement risk mitigation strategies. The system allows you to track the effectiveness of your strategies and make adjustments as needed.",
            },
        ],
    },
    "/ship-management": {
        title: "Understanding Ship Management",
        steps: [
            {
                title: "1. Ship Management Overview",
                context:
                    "The Ship Management module allows you to manage all aspects of your fleet. From here, you can track vessel performance, manage maintenance schedules, and ensure compliance with regulations.",
            },
            {
                title: "2. Vessel Information",
                context:
                    "Access detailed information about each vessel in your fleet, including specifications, history, and current status. You can update vessel details and add new vessels to your fleet.",
            },
            {
                title: "3. Maintenance and Compliance",
                context:
                    "Schedule and track maintenance tasks to keep your vessels in optimal condition. Monitor compliance with international and local regulations to avoid penalties and delays.",
            },
        ],
    },
    "/port-service": {
        title: "Understanding Port Service",
        steps: [
            {
                title: "1. Port Service Overview",
                context:
                    "The Port Service page provides information and services related to ports. It helps you plan port calls, manage port-related expenses, and coordinate with port authorities and service providers.",
            },
            {
                title: "2. Port Information",
                context:
                    "Access a comprehensive database of ports worldwide. Get information on port facilities, services, and costs to make informed decisions for your voyages.",
            },
            {
                title: "3. Service Directory",
                context:
                    "Find and connect with port service providers, such as agents, surveyors, and suppliers. The directory helps you find reliable partners for your port operations.",
            },
        ],
    },
    "/fuel-supply": {
        title: "Understanding Fuel Supply",
        steps: [
            {
                title: "1. Fuel Supply Management",
                context:
                    "The Fuel Supply module helps you manage the entire fuel procurement process, from planning and purchasing to delivery and consumption.",
            },
            {
                title: "2. Fuel Market Analysis",
                context:
                    "Analyze the fuel market to identify trends and opportunities. The system provides data and tools to help you make cost-effective fuel purchasing decisions.",
            },
            {
                title: "3. Bunkering Operations",
                context:
                    "Manage bunkering operations, including supplier selection, nomination, and delivery coordination. Track fuel quality and quantity to ensure you get what you pay for.",
            },
        ],
    },
    "/accounting": {
        title: "Understanding Accounting",
        steps: [
            {
                title: "1. Accounting Dashboard",
                context:
                    "The Accounting dashboard provides a financial overview of your operations. Track revenues, expenses, and profitability in real-time.",
            },
            {
                title: "2. Voyage Accounting",
                context:
                    "Manage the financial aspects of each voyage. Track voyage-related costs and revenues, and generate voyage profit and loss statements.",
            },
            {
                title: "3. Invoicing and Payments",
                context:
                    "Create and manage invoices for your services. Track payments from customers and manage payments to suppliers and partners.",
            },
        ],
    },
    "/addressBook": {
        title: "Understanding the Address Book",
        steps: [
            {
                title: "1. Address Book Overview",
                context:
                    "The Address Book is your central repository for managing contacts. You can store contact details for individuals and companies you work with.",
            },
            {
                title: "2. Add and Manage Contacts",
                context:
                    "Add new contacts with their name, email, phone number, and other relevant details. You can also edit or delete existing contacts.",
            },
        ],
    },
    "/port-information": {
        title: "Understanding Port Information",
        steps: [
            {
                title: "1. Port Information Database",
                context:
                    "Access a comprehensive database of ports worldwide. Get detailed information about port facilities, services, and operational parameters.",
            },
            {
                title: "2. Search and Filter",
                context:
                    "Search for specific ports by name, country, or region. Use filters to narrow down the results based on your requirements.",
            },
        ],
    },
    "/support": {
        title: "Understanding the Support Page",
        steps: [
            {
                title: "1. Get Help and Support",
                context:
                    "The Support page is your gateway to getting help with any issues or questions you may have. You can find answers to frequently asked questions and contact our support team.",
            },
            {
                title: "2. Contact Support",
                context:
                    "If you cannot find an answer to your question in the FAQ, you can submit a support ticket to our team. Please provide as much detail as possible to help us resolve your issue quickly.",
            },
        ],
    },
    "/messagebox": {
        title: "Understanding the Message Box",
        steps: [
            {
                title: "1. Your Personal Mailbox",
                context:
                    "The Message Box is your internal messaging system. Here you can find important notifications, alerts, and messages from other users or the system itself.",
            },
            {
                title: "2. Reading and Managing Messages",
                context:
                    "Click on a message to read its content. You can mark messages as read, archive them, or delete them to keep your inbox organized.",
            },
        ],
    },
    "/supportinformation": {
        title: "Understanding Support Information",
        steps: [
            {
                title: "1. Detailed Support Information",
                context:
                    "This page provides detailed information about a specific support ticket or issue. You can view the history of the ticket, including all communications with the support team.",
            },
        ],
    },
    "/profile": {
        title: "Understanding Your Profile",
        steps: [
            {
                title: "1. Your Personal Information",
                context:
                    "The Profile page displays your personal information, such as your name, email address, and role within the organization.",
            },
            {
                title: "2. Update Your Details",
                context:
                    "You can update your personal details and change your password from this page. Keeping your information up-to-date is important for security and communication.",
            },
        ],
    },
    "/saved": {
        title: "Understanding Saved Results",
        steps: [
            {
                title: "1. Your Saved Calculations",
                context:
                    "This page lists all the calculation results you have saved for future reference. You can easily access and review your past estimations.",
            },
            {
                title: "2. Manage Saved Results",
                context:
                    "From here, you can view the details of each saved result, compare different scenarios, or delete results that are no longer needed.",
            },
        ],
    },
    "/smart-laytime": {
        title: "Understanding Smart Laytime",
        steps: [
            {
                title: "1. Electronic Laytime Calculation",
                context:
                    "The Electric Laytime page allows you to calculate laytime based on electronic statements of fact. This automates a traditionally manual and time-consuming process.",
            },
            {
                title: "2. Statement of Facts (SOF)",
                context:
                    "Import or manually enter data from the Statement of Facts to automatically calculate laytime, demurrage, or despatch.",
            },
        ],
    },
    "/smart-sof": {
        title: "Understanding Smart Statement of Fact",
        steps: [
            {
                title: "1. Electronic Statement of Facts (SOF)",
                context:
                    "This page allows you to create, view, and manage electronic Statements of Fact. An SOF is a critical document that records all activities during a vessel's port call.",
            },
            {
                title: "2. Create and Share SOF",
                context:
                    "You can create a new SOF, add events and timings, and share it with relevant parties for verification and approval.",
            },
        ],
    },
    "/google": {
        title: "Google Integration",
        steps: [
            {
                title: "1. Google Integration",
                context: "This page handles authentication and data exchange with Google services.",
            },
        ],
    },
    "/oauth2/redirect": {
        title: "OAuth2 Redirect",
        steps: [
            {
                title: "1. Authentication Redirect",
                context: "This is a redirect page used during the OAuth2 authentication process. You will be redirected back to the application shortly.",
            },
        ],
    },
};
